"use client";

import { useEffect } from "react";

/** Address-bar only — no navigation, no RSC refetch. */
export default function SoftReplaceUrl({ href }: { href: string }) {
  useEffect(() => {
    const url = new URL(href, window.location.href);
    const next = `${url.pathname}${url.search}${window.location.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (current === next) return;
    window.history.replaceState(window.history.state, "", next);
  }, [href]);

  return null;
}
